import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import ReactSelect from 'react-select'

import Select from '../components/form/Select'
import { Link } from 'react-router-dom'

import { httpClient } from '../utils/httpClient';

import './FloatingSearch.css'

const FloatingSearch = (props) => {
  const [searchParams, setSearchParams] = useState({
    city_id: 1,
    brand: '',
    condition: 'Capella Certified'
  })
  const [activeSearchTab, setActiveSearchTab] = useState(1)

  // Search parameters
  const [carBrand, setCarBrand] = useState([])
  const [carCities, setCarCities] = useState([])
  const [bikeBrand, setBikeBrand] = useState([])
  const [bikeCities, setBikeCities] = useState([])
  const [bikeConditions, setBikeConditions] = useState([])
  const [carConditions, setCarConditions] = useState([])

  const [selectedCarBrand, setSelectedCarBrand] = useState(null)
  const [selectedCity, setSelectedCity] = useState(null)
  const [selectedCondition, setSelectedCondition] = useState(null)

  // TODO: move it to services folder or other if needed on other page
  const fetchDataSearch = async () => {
    const result = await httpClient.get('/inventory/search')
    setCarBrand(result.data.car_name)
    setBikeBrand(result.data.bike_name)
    setCarCities(result.data.car_city)
    setBikeCities(result.data.bike_city)
  }

  const fetchBikeConditions = async () => {
    const res = await httpClient.get('/bike/search')
    setBikeConditions(res.data.condition) // TODO: beautify the string
  }

  const fetchCarConditions = async () => {
    const res = await httpClient.get('/car/search')
    setCarConditions(res.data.condition) // TODO: beautify the string
  }

  useEffect(() => {
    localStorage.removeItem("city");
    localStorage.removeItem("brand");
    localStorage.removeItem("condition");
    fetchDataSearch();
    fetchBikeConditions();
    fetchCarConditions();
  }, [])

  const setCityHandleChange = (city_id, value) => {
    localStorage.setItem("city", city_id);
    setSelectedCity(value);
  }

  const setBrandHandleChange = (brand, value) => {
    localStorage.setItem("brand", brand);
    setSelectedCarBrand(value)
  }

  const setConditionHandleChange = (condition, value) => {
    localStorage.setItem("condition", condition);
    setSelectedCondition(value)
  }

  const normalizeSelectSearch = (key, value) => {
    setSelectedCarBrand(value)
  }

  const conditionOptions = activeSearchTab === 1 ? carConditions : bikeConditions;
  const brandOptions = activeSearchTab === 1 ? carBrand : bikeBrand;
  const cityOptions = activeSearchTab === 1 ? carCities : bikeCities;

  return (
    <div className="floating-search">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="floating-search-container">
              <div className="floating-search-tab">
                <div className={`floating-search-tab-item ${activeSearchTab === 1 ? 'active' : ''}`} onClick={() => setActiveSearchTab(1)}>
                  <span>Cari Mobil</span>
                </div>
                <div className={`floating-search-tab-item ${activeSearchTab === 2 ? 'active' : ''}`} onClick={() => setActiveSearchTab(2)}>
                  <span>Cari Motor</span>
                </div>
              </div>
              <div className="floating-search-wrapper">
                <div className="floating-search-field">
                  <label htmlFor="brand">MEREK</label>
                  <ReactSelect
                    classNamePrefix="select-search"
                    placeholder="Ketik Merek"
                    className="select-search-container"
                    value={selectedCarBrand}
                    onChange={(value) => setBrandHandleChange(value.value, value)}
                    options={brandOptions.map((opt) => ({ label: opt.label, value: opt.value }))}
                  />
                </div>
                <div className="floating-search-field d-only">
                  <label htmlFor="lokasi">LOKASI</label>
                  <ReactSelect
                    classNamePrefix="select-search"
                    placeholder="Ketik Lokasi"
                    className="select-search-container"
                    value={selectedCity}
                    onChange={(value) => setCityHandleChange(value.value, value)}
                    options={cityOptions.map((opt) => ({ label: opt.label, value: opt.value }))}
                  />
                </div>
                <div className="floating-search-field d-only" style={{ borderRight: 0 }}>
                  <label htmlFor="kondisi">KONDISI</label>
                  <ReactSelect
                    classNamePrefix="select-search"
                    placeholder="Ketik Kondisi"
                    className="select-search-container"
                    value={selectedCondition}
                    onChange={(value) => setConditionHandleChange(value.value, value)}
                    options={conditionOptions.map((opt) => ({ label: opt, value: opt }))}
                  />
                </div>
                <Link className="floating-search-button" to={activeSearchTab == 1 ? "/gallery/mobil" : "/gallery/motor"}>
                  <span>
                    <FontAwesomeIcon icon={faSearch} />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FloatingSearch
